import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/imgs/channel-poster/banner_blue.jpg'
import _imports_1 from '../../assets/imgs/channel-poster/banner_red.jpg'
import _imports_2 from '../../assets/imgs/channel-poster/module-title-01_blue.jpg'
import _imports_3 from '../../assets/imgs/channel-poster/module-title-01_red.jpg'
import _imports_4 from '../../assets/imgs/channel-poster/module-title_blue.jpg'
import _imports_5 from '../../assets/imgs/channel-poster/module-title_red.jpg'


const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "poster-container" }
const _hoisted_3 = { class: "html-fix-container" }
const _hoisted_4 = { class: "banner" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: "蛋叔月报"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  alt: "蛋叔月报"
}
const _hoisted_7 = {
  key: 2,
  class: "content"
}
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "mt5 font12" }
const _hoisted_10 = {
  key: 3,
  class: "content"
}
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "mt5 font12" }
const _hoisted_13 = { class: "padding-box" }
const _hoisted_14 = { class: "module-box rank-box" }
const _hoisted_15 = { class: "module-header" }
const _hoisted_16 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_17 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_18 = { class: "tips" }
const _hoisted_19 = { class: "module-content" }
const _hoisted_20 = { class: "part" }
const _hoisted_21 = {
  key: 0,
  class: "list"
}
const _hoisted_22 = {
  key: 1,
  class: "empty"
}
const _hoisted_23 = { class: "part" }
const _hoisted_24 = {
  key: 0,
  class: "list"
}
const _hoisted_25 = {
  key: 1,
  class: "empty"
}
const _hoisted_26 = { class: "part" }
const _hoisted_27 = {
  key: 0,
  class: "list"
}
const _hoisted_28 = {
  key: 1,
  class: "empty"
}
const _hoisted_29 = { class: "part" }
const _hoisted_30 = {
  key: 0,
  class: "list"
}
const _hoisted_31 = {
  key: 1,
  class: "empty"
}
const _hoisted_32 = {
  key: 0,
  class: "module-box new-box"
}
const _hoisted_33 = { class: "module-header" }
const _hoisted_34 = {
  key: 0,
  src: _imports_4,
  alt: "月新增品牌"
}
const _hoisted_35 = {
  key: 1,
  src: _imports_5,
  alt: "月新增品牌"
}
const _hoisted_36 = { class: "title" }
const _hoisted_37 = { class: "list" }
const _hoisted_38 = {
  class: "font-bold",
  style: {"line-height":"1.3"}
}
const _hoisted_39 = { class: "mt8" }
const _hoisted_40 = {
  key: 1,
  class: "module-box topic-box"
}
const _hoisted_41 = { class: "module-header" }
const _hoisted_42 = { class: "list" }
const _hoisted_43 = { class: "title" }
const _hoisted_44 = ["src", "alt"]
const _hoisted_45 = {
  key: 2,
  class: "module-box recommend-brand-box"
}
const _hoisted_46 = { class: "module-header" }
const _hoisted_47 = { class: "line-title" }
const _hoisted_48 = { class: "text" }
const _hoisted_49 = { class: "list" }
const _hoisted_50 = ["src", "alt"]
const _hoisted_51 = {
  class: "font-bold mt5",
  style: {"line-height":"1.3"}
}
const _hoisted_52 = { class: "mt5" }
const _hoisted_53 = {
  key: 3,
  class: "module-box recommend-product-box"
}
const _hoisted_54 = { class: "module-header" }
const _hoisted_55 = { class: "line-title" }
const _hoisted_56 = { class: "text" }
const _hoisted_57 = { class: "list" }
const _hoisted_58 = ["src", "alt"]
const _hoisted_59 = { class: "content" }
const _hoisted_60 = { class: "logo-title" }
const _hoisted_61 = ["src", "alt"]
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "mt10 font-bold font12 product-title" }
const _hoisted_65 = { class: "mt5" }
const _hoisted_66 = {
  key: 0,
  class: "two-ellipsis"
}
const _hoisted_67 = { class: "img-container" }
const _hoisted_68 = ["src"]
const _hoisted_69 = ["href", "download"]
const _hoisted_70 = ["src"]
const _hoisted_71 = { class: "action-list" }
const _hoisted_72 = { class: "action-list" }

import { getCurrentInstance, ref, computed, watch } from 'vue'
import SelectChannel from '@/components/SelectChannel.vue'
import { getProductDetail } from '@/apis/product'
import html2canvas from 'html2canvas'
import { getWeekOfMonth, getLastMonth, getLastDayOfLastMonth, getFirstAndLastDayOfLastWeek } from '@/utils'
import { getChannelPosterApi, getTopicDetailApi } from '@/apis/channel'
import { getBrandListApi } from '@/apis/brand'


export default /*@__PURE__*/_defineComponent({
  __name: 'Poster',
  setup(__props) {

const { proxy } = getCurrentInstance() as any

const lastMonth = getLastMonth() // 上个月月份
const lastDayOfLastMonth = getLastDayOfLastMonth() // 上个月最后一天
const dayOfLastWeek = getFirstAndLastDayOfLastWeek() // 上一周第一天和最后一天的日期
const weekOfMonth = getWeekOfMonth(dayOfLastWeek.lastDay) // 当前周是本月的第几周

const settingAreaHeight = computed(() => { // 配置区高度
    return window.innerHeight - 145
})

const brandProps = {
    label: 'name',
    value: 'id'
}
const brandList = ref<any[]>([])
const onGetBrandList = async () => {
    const {code, data, msg} = await getBrandListApi({status: 1}) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    brandList.value = data
}
onGetBrandList()

// 渠道监听
const channel_no = ref('')

const type = ref(1) // 海报类型：1-周报，2-月报
const getChannelData = async () => {
    let { code, data, msg } = await getChannelPosterApi(type.value, channel_no.value) as any
    if (code != 200) return proxy.$message({ type: 'error', message: msg })

    rank.value = data

    if (data.length == 0) return proxy.$message({ type: 'warning', message: '该渠道暂时没有数据' })
}

// 监听渠道和海报类型变化进行数据重新获取
watch(() => [channel_no.value, type.value], (newVal, oldVal) => {
    if (newVal[0] && newVal[1]) {
        getChannelData()
    }
})


const rank = ref<any>({ // 品牌排名
})

/**************************************  新增品牌--begin **************************************/
const newBrandsNum = ref('')
const newBrandsId = ref<any>([])
const newBrands = ref<any>([])
const onNewBrandsChange = () => {
    newBrands.value = brandList.value.filter(item => newBrandsId.value.includes(item.id))
}
/**************************************  新增品牌--end **************************************/

/**************************************  推荐品牌--begin **************************************/
const recommendBrandsId = ref<any>([])
const recommendBrands = ref<any>([])
const onRecommendBrandsChange = () => {
    recommendBrands.value = brandList.value.filter(item => recommendBrandsId.value.includes(item.id))
}
/**************************************  推荐品牌--end **************************************/

/**************************************  专题活动--begin **************************************/
const topicsShow = computed(() => {
    return topics.value.findIndex(item => item.id) > -1
})
const topics = ref<any>([
    {
        id: '',
        title: '',
        image_path: ''
    }
])
// 向推荐列表中添加一行
const addTopicRow = () => {
    let row = {
        id: '',
        title:      '',
        image_path: '',
    }
    topics.value.push(row)
}

const getTopicInfo = async (row, index = -1) => {
    const { id } = row
    if (!id) { return clearTopicRowData(index) }

    // 检查是否有重复
    // if (topics.value.filter(item => item.id == id).length > 1) return proxy.$message({ type: 'error', message: '已存在相同活动专题' })
    
    const { code, data, msg } = await getTopicDetailApi(id) as any
    if (code != 200) {
        return proxy.$message({ type: 'error', message: msg })
    }
    
    if (!data) {
        clearTopicRowData(index)
        return proxy.$message({ type: 'error', message: '未查询到该活动专题' })
    }
    delete(data.id)
    data.id = id || 0

    Object.assign(topics.value[index], data)
}
// 清空指定行数据
const clearTopicRowData = (index:number) => {
    topics.value[index].id = ''
    topics.value[index].title = ''
    topics.value[index].image_path = ''
}
// 删除一行
const delTopicRow = (row, index) => {
    const { id } = row
    proxy.$confirm(`确定要删除该活动专题吗？`, '提示', {
        type: 'warning'
    }).then(() => {
        if (topics.value.length > 1) {
            topics.value.splice(index, 1)
        } else {
            clearTopicRowData(0)
        }
    }).catch(() => {
        console.log('取消删除')
    })
}
/**************************************  活动专题--end **************************************/

/**************************************  推荐商品--begin **************************************/
const productsShow = computed(() => {
    return products.value.findIndex(item => item.product_id) > -1
})
const products = ref<any>([
    {
        product_id: '',
        title: '',
        price: '',
        image_path: '',
        brand_name: '',
        brand_image_path: '',
        reason: ''
    }
])
// 向推荐列表中添加一行
const addProductRow = () => {
    if (products.value.length >= 6) return proxy.$message({ type: 'warning', message: '推荐商品最多添加 6 条' })
    let row = {
        relevance_id: 0,
        product_id: '',
        title:      '',
        price:      '',
        image_path: '',
        sort: 0
    }
    products.value.push(row)
}

const getProductInfo = async (row, index = -1) => {
    const { id, product_id } = row
    if (!product_id) { return clearProductRowData(index) }

    // 检查是否有重复
    if (products.value.filter(item => item.product_id == product_id).length > 1) return proxy.$message({ type: 'error', message: '已存在相同商品' })
    
    const { code, data, msg } = await getProductDetail({product_id}) as any
    if (code != 200) {
        return proxy.$message({ type: 'error', message: msg })
    }
    
    if (!data) {
        clearProductRowData(index)
        return proxy.$message({ type: 'error', message: '未查询到该商品' })
    }
    delete(data.id)
    data.id = id || 0

    Object.assign(products.value[index], data)
}
// 清空指定行数据
const clearProductRowData = (index:number) => {
    products.value[index].product_id = ''
    products.value[index].title = ''
    products.value[index].price = ''
    products.value[index].reason = ''
}
// 删除一行
const delProductRow = (row, index) => {
    const { id } = row
    proxy.$confirm(`确定要删除该商品吗？`, '提示', {
        type: 'warning'
    }).then(() => {
        if (products.value.length > 1) {
            products.value.splice(index, 1)
        } else {
            clearProductRowData(0)
        }
    }).catch(() => {
        console.log('取消删除')
    })
}
/**************************************  推荐商品--end **************************************/

/**************************************  生成海报--begin  **************************************/
const isPosterShow = ref(false)
const fullscreenLoading = ref(false)
const poster_img = ref('')
const createPoster = () => {
    if (checkData()) {
        fullscreenLoading.value = true
        const el = document.getElementById('htmlContainer') as any
        const { width, height, toTop, toLeft } = getImgOffset()
        html2canvas(el, {
            backgroundColor: '#000',
            width: width,
            height: height,
            x: toLeft,
            y: toTop,
            scale: 3,
            useCORS: true,  // 如果图片是跨域的，确保允许跨域处理
        }).then(canvas => {
            isPosterShow.value = true;
            let imgUrl = canvas.toDataURL("image/png");
            poster_img.value = imgUrl;
            
            fullscreenLoading.value = false
        });
    }
}
const getImgOffset = () => {
    const element = document.getElementById('htmlContainer') as any;
    const rect = element.getBoundingClientRect();
    
    let width = rect.width,
        height = rect.height,
        toTop = rect.top + window.scrollY,
        toLeft = rect.left + window.scrollX;

    return {
        width,
        height,
        toTop,
        toLeft
    }
}
/**************************************  生成海报--end  **************************************/

// 触发下载事件
const triggerDownload = () => {
    proxy.$refs.downloadA.click()
}

// 校验数据是否完整
const checkData = () => {
    // 校验渠道是否选择
    if (!channel_no.value) {
        proxy.$message({ type: 'error', message: '请选择渠道' })
        return false
    }

    // 校验新增品牌和新增品牌数量是否同时存在
    if ((!newBrandsNum.value && newBrands.value.length !== 0) || (newBrandsNum.value && newBrands.value.length === 0)) {
        proxy.$message({ type: 'error', message: '新增品牌数量 与 新增品牌 必须同时填写' })
        return false
    }

    // 检验推荐专题数据是否完整
    let errTopicRowIndex = topics.value.findIndex(item => item.id && !item.title)
    if (errTopicRowIndex !== -1) {
        proxy.$message({ type: 'error', message: `专题活动缺少文案，请重新生成` })
        return false
    }

    // 检验推荐商品数据是否完整
    let errBrandRowIndex = recommendBrands.value.findIndex(item => item.product_id || !item.name)
    if (errBrandRowIndex !== -1) {
        proxy.$message({ type: 'error', message: `推荐商品第 ${errBrandRowIndex+1} 行数据有误，请检查后重新提交` })
        return false
    }

    return true
}

/**
 * 根据指定长度截取字符串
 *  str：截取的字符串
 *  maxlength: 允许展示的最大长度
 *  float：允许浮动的长度（即使用几个字符的位置替换为...）
 * */
const subStringByNum = (str: string, maxlength: number, float: number = 2) => {
    if (str.length <= maxlength) return str
    return str.substring(0, maxlength - float) + '...'
}

// 监听数据变化，将海报置为可编辑状态
watch(() => [channel_no.value, type.value, newBrandsNum.value, newBrands.value, recommendBrands.value, products.value], (newVal, oldVal) => {
    isPosterShow.value = false
}, { deep: true })

// 重新加载页面
const reloadPage = () => {
    window.location.reload()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_row, { class: "mb10" }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: isPosterShow.value ? 'info' : 'warning',
            onClick: createPoster,
            disabled: isPosterShow.value
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("生成海报")
            ])),
            _: 1
          }, 8, ["type", "disabled"])), [
            [
              _directive_loading,
              fullscreenLoading.value,
              void 0,
              {
                fullscreen: true,
                lock: true
              }
            ]
          ]),
          _createVNode(_component_el_button, {
            type: !isPosterShow.value ? 'info' : 'primary',
            disabled: !isPosterShow.value,
            onClick: triggerDownload
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("下载海报")
            ])),
            _: 1
          }, 8, ["type", "disabled"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("div", {
          id: "htmlContainer",
          class: _normalizeClass(['html-container', type.value==1 ? 'week-theme' : 'month-theme'])
        }, [
          _createElementVNode("div", _hoisted_4, [
            (type.value==1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true),
            (type.value==2)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true),
            (type.value==1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, "SAAS  " + _toDisplayString(_unref(dayOfLastWeek).lastDay.split('-')[0]) + "月第" + _toDisplayString(_unref(weekOfMonth)) + "周", 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(dayOfLastWeek).firstDay + ' 至 ' + _unref(dayOfLastWeek).lastDay), 1)
                ]))
              : _createCommentVNode("", true),
            (type.value==2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, "SAAS " + _toDisplayString(_unref(lastMonth)) + "月", 1),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(lastMonth) + '-01 至 ' + _unref(lastDayOfLastMonth)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "h2" }, "数据总览", -1)),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (type.value==1)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                  : _createCommentVNode("", true),
                (type.value==2)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, "本品牌排名根据您的上" + _toDisplayString(type.value==1 ? '周' : '月') + "实际销售数据显示", 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "part-title" }, [
                    _createElementVNode("span"),
                    _createElementVNode("p", null, "蛋糕"),
                    _createElementVNode("span")
                  ], -1)),
                  (rank.value['蛋糕']?.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rank.value['蛋糕'], (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "item",
                            key: item['排名']
                          }, [
                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "index" }, null, -1)),
                            _createElementVNode("div", {
                              style: _normalizeStyle({'font-size': item['品牌'].length > 8 ? '11px' : '12px'})
                            }, _toDisplayString(item['品牌']), 5)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, "暂无数据，欢迎对接"))
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "part-title" }, [
                    _createElementVNode("span"),
                    _createElementVNode("p", null, "零食"),
                    _createElementVNode("span")
                  ], -1)),
                  (rank.value['零食']?.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rank.value['零食'], (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "item",
                            key: item['排名']
                          }, [
                            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "index" }, null, -1)),
                            _createElementVNode("div", {
                              style: _normalizeStyle({'font-size': item['品牌'].length > 8 ? '10px' : '12px'})
                            }, _toDisplayString(item['品牌']), 5)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, "暂无数据，欢迎对接"))
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "part-title" }, [
                    _createElementVNode("span"),
                    _createElementVNode("p", null, "鲜花"),
                    _createElementVNode("span")
                  ], -1)),
                  (rank.value['鲜花']?.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rank.value['鲜花'], (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "item",
                            key: item['排名']
                          }, [
                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "index" }, null, -1)),
                            _createElementVNode("div", {
                              style: _normalizeStyle({'font-size': item['品牌'].length > 8 ? '11px' : '12px'})
                            }, _toDisplayString(item['品牌']), 5)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_28, "暂无数据，欢迎对接"))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "part-title" }, [
                    _createElementVNode("span"),
                    _createElementVNode("p", null, "电子券"),
                    _createElementVNode("span")
                  ], -1)),
                  (rank.value['电子券']?.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rank.value['电子券'], (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "item",
                            key: item['排名']
                          }, [
                            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "index" }, null, -1)),
                            _createElementVNode("div", {
                              style: _normalizeStyle({'font-size': item['品牌'].length > 8 ? '11px' : '12px'})
                            }, _toDisplayString(item['品牌']), 5)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, "暂无数据，欢迎对接"))
                ])
              ])
            ]),
            (newBrandsNum.value && newBrands.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    (type.value==1)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_34))
                      : _createCommentVNode("", true),
                    (type.value==2)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_36, "新增" + _toDisplayString(newBrandsNum.value) + "个品牌", 1),
                    _createElementVNode("ul", _hoisted_37, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newBrands.value, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "item",
                          key: item.id
                        }, [
                          _createElementVNode("p", _hoisted_38, _toDisplayString(item.name), 1),
                          _createElementVNode("p", _hoisted_39, "id:" + _toDisplayString(item.id), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (topicsShow.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "line-title" }, [
                      _createElementVNode("span", { class: "before" }),
                      _createElementVNode("div", { class: "text" }, "活动推荐"),
                      _createElementVNode("span", { class: "after" })
                    ], -1)),
                    _createElementVNode("ul", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topics.value, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "item",
                          key: item.id
                        }, [
                          _createElementVNode("p", _hoisted_43, _toDisplayString(item.title), 1),
                          _createElementVNode("img", {
                            src: item.image_path,
                            alt: item.title
                          }, null, 8, _hoisted_44)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (recommendBrands.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "before" }, null, -1)),
                      _createElementVNode("div", _hoisted_48, _toDisplayString(type.value == 1 ? '周' : '月') + "推荐品牌", 1),
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "after" }, null, -1))
                    ]),
                    _createElementVNode("ul", _hoisted_49, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendBrands.value, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "item",
                          key: item
                        }, [
                          _createElementVNode("img", {
                            src: item.image_path,
                            alt: item.name
                          }, null, 8, _hoisted_50),
                          _createElementVNode("p", _hoisted_51, _toDisplayString(item.name), 1),
                          _createElementVNode("p", _hoisted_52, "id:" + _toDisplayString(item.id), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (productsShow.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "before" }, null, -1)),
                      _createElementVNode("div", _hoisted_56, _toDisplayString(type.value == 1 ? '周' : '月') + "推荐商品", 1),
                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "after" }, null, -1))
                    ]),
                    _createElementVNode("ul", _hoisted_57, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (item.product_id)
                            ? (_openBlock(), _createElementBlock("li", {
                                class: "item",
                                key: item.product_id
                              }, [
                                _createElementVNode("img", {
                                  class: "main-img",
                                  src: item.image_path,
                                  alt: item.name
                                }, null, 8, _hoisted_58),
                                _createElementVNode("div", _hoisted_59, [
                                  _createElementVNode("div", _hoisted_60, [
                                    _createElementVNode("img", {
                                      class: "logo",
                                      src: item.brand_image_path,
                                      alt: item.brand_name
                                    }, null, 8, _hoisted_61),
                                    (item.second_brand_name)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(item.second_brand_name), 1))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(item.brand_name), 1))
                                  ]),
                                  _createElementVNode("p", _hoisted_64, _toDisplayString(item.title), 1),
                                  _createElementVNode("p", _hoisted_65, "id:" + _toDisplayString(item.product_id), 1),
                                  (item.reason)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, "推荐理由:" + _toDisplayString(item.reason), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "footer-container" }, [
            _createElementVNode("div", { class: "footer" }, [
              _createElementVNode("p", null, "*该数据仅供参考"),
              _createElementVNode("p", { class: "mt8" }, "对账等数据以接口实际为准")
            ])
          ], -1))
        ], 2), [
          [_vShow, !isPosterShow.value]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_67, [
          _createElementVNode("img", {
            src: poster_img.value,
            class: "img"
          }, null, 8, _hoisted_68),
          _createElementVNode("a", {
            ref: "downloadA",
            href: poster_img.value,
            download: channel_no.value,
            style: {"display":"none"}
          }, [
            _createElementVNode("img", {
              src: poster_img.value,
              class: "img"
            }, null, 8, _hoisted_70)
          ], 8, _hoisted_69)
        ], 512), [
          [_vShow, isPosterShow.value]
        ])
      ])
    ]),
    _createVNode(_component_el_form, {
      class: "form edit-form",
      ref: "editForm",
      "label-width": "80px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, { height: settingAreaHeight.value }, {
          default: _withCtx(() => [
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "module-title" }, "添加渠道", -1)),
            _createVNode(_component_el_form_item, {
              label: "渠道号",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(SelectChannel, {
                  modelValue: channel_no.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((channel_no).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "海报类型",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: type.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((type).value = $event)),
                  class: "ml-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: 2,
                      size: "large"
                    }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode("上月月报")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: 1,
                      size: "large"
                    }, {
                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                        _createTextVNode("上周周报")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "module-title mt20" }, "新增品牌", -1)),
            _createVNode(_component_el_form_item, { label: "新增数量" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: newBrandsNum.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newBrandsNum).value = $event)),
                  placeholder: "请输入新增数量",
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (newBrandsNum.value = newBrandsNum.value.replace(/[^0-9]/g,'')))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "新增品牌" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  disabled: !newBrandsNum.value,
                  class: "mt10",
                  modelValue: newBrandsId.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newBrandsId).value = $event)),
                  filterable: "",
                  clearable: "",
                  multiple: "",
                  "multiple-limit": newBrandsNum.value,
                  options: brandList.value,
                  props: brandProps,
                  placeholder: "请选择新增品牌",
                  onChange: onNewBrandsChange
                }, null, 8, ["disabled", "modelValue", "multiple-limit", "options"])
              ]),
              _: 1
            }),
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "module-title mt20" }, "专题活动", -1)),
            _createVNode(_component_el_form_item, { label: "专题活动" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  data: topics.value,
                  border: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "专题活动ID",
                      width: "200px"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          modelValue: scope.row.id,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.id) = $event),
                          modelModifiers: { trim: true },
                          placeholder: "请输入专题活动ID",
                          onChange: ($event: any) => (getTopicInfo(scope.row, scope.$index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { label: "文案" }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          modelValue: scope.row.title,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.title) = $event),
                          placeholder: "请输入文案",
                          "show-word-limit": "",
                          type: "textarea",
                          rows: 3
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "操作",
                      width: "70px"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_71, [
                          _createVNode(_component_el_button, {
                            type: "danger",
                            size: "small",
                            onClick: ($event: any) => (delTopicRow(scope.row, scope.$index))
                          }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode("删除")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createVNode(_component_el_row, {
                  justify: "end",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "mt10",
                      type: "success",
                      size: "small",
                      onClick: addTopicRow
                    }, {
                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                        _createTextVNode("新增一行")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "module-title mt20" }, "品牌推荐", -1)),
            _createVNode(_component_el_form_item, { label: "推荐品牌" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  modelValue: recommendBrandsId.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((recommendBrandsId).value = $event)),
                  filterable: "",
                  clearable: "",
                  multiple: "",
                  options: brandList.value,
                  props: brandProps,
                  placeholder: "请选择推荐品牌",
                  onChange: onRecommendBrandsChange
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "module-title mt20" }, "商品推荐", -1)),
            _createVNode(_component_el_form_item, { label: "推荐商品" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  data: products.value,
                  border: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "商品ID",
                      width: "130px"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          modelValue: scope.row.product_id,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.product_id) = $event),
                          modelModifiers: { trim: true },
                          placeholder: "商品ID",
                          onChange: ($event: any) => (getProductInfo(scope.row, scope.$index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "title",
                      label: "商品名称"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "推荐理由",
                      width: "200px"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          modelValue: scope.row.reason,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.reason) = $event),
                          maxlength: "28",
                          placeholder: "推荐理由(限制28字以内)",
                          "show-word-limit": "",
                          type: "textarea",
                          rows: 3
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "操作",
                      width: "70px"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_72, [
                          _createVNode(_component_el_button, {
                            type: "danger",
                            size: "small",
                            onClick: ($event: any) => (delProductRow(scope.row, scope.$index))
                          }, {
                            default: _withCtx(() => _cache[27] || (_cache[27] = [
                              _createTextVNode("删除")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createVNode(_component_el_row, {
                  justify: "end",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "mt10",
                      type: "success",
                      size: "small",
                      onClick: addProductRow
                    }, {
                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                        _createTextVNode("新增一行")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["height"]),
        _createVNode(_component_el_form_item, { style: {"margin-top":"-40px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: reloadPage
                }, {
                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                    _createTextVNode("清除")
                  ])),
                  _: 1
                }),
                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: isPosterShow.value ? 'info' : 'warning',
                  onClick: createPoster,
                  disabled: isPosterShow.value
                }, {
                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                    _createTextVNode("生成海报")
                  ])),
                  _: 1
                }, 8, ["type", "disabled"])), [
                  [
                    _directive_loading,
                    fullscreenLoading.value,
                    void 0,
                    {
                      fullscreen: true,
                      lock: true
                    }
                  ]
                ]),
                _createVNode(_component_el_button, {
                  disabled: !isPosterShow.value,
                  type: !isPosterShow.value ? 'info' : 'primary',
                  onClick: triggerDownload
                }, {
                  default: _withCtx(() => _cache[36] || (_cache[36] = [
                    _createTextVNode("下载海报")
                  ])),
                  _: 1
                }, 8, ["disabled", "type"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}
}

})